import axios from "@/utils/request"

function GET_LIST(params) {
    return axios.get("/template/ACustomTemplateGroup/index", {
        params: {
            ...params
        }
    } )
}
function DELE(params) {
    return  axios.post("/template/ACustomTemplateGroup/delete",{
        ids:params
    } )
}

function ADD_DATA() {
    return  axios.get("/template/ACustomTemplateGroup/add",{
        params: {}
    } )
}

function SUBMIT_ADD(params) {
    return axios.post("/template/ACustomTemplateGroup/addPost",{...params})
}

function SUBMIT_EDIT(params) {
    return axios.post("/template/ACustomTemplateGroup/editPost",{...params})
}

function EDIT_DATA(params) {
    return axios.get("/template/ACustomTemplateGroup/edit",{
        params: {id: params}
    } )
}

export default {
    GET_LIST,
    DELE,
    ADD_DATA,
    SUBMIT_ADD,
    SUBMIT_EDIT,
    EDIT_DATA
}
